import { render, staticRenderFns } from "./ProjectTypeList.vue?vue&type=template&id=63891306&scoped=true"
import script from "./ProjectTypeList.vue?vue&type=script&lang=js"
export * from "./ProjectTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63891306",
  null
  
)

export default component.exports